import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=4a20bf0a&"
import script from "./Callback.vue?vue&type=script&lang=ts&"
export * from "./Callback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports